import { Fragment } from 'react';
// MUI
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha } from '@mui/material/styles';
// CUSTOM DEFINED HOOK
import { useSettings } from '@/hooks/useSettings';
import useLayout from '../context/useLayout';
// CUSTOM ICON COMPONENTS
import Menu from '@/icons/Menu';
import ThemeIcon from '@/icons/ThemeIcon';
// CUSTOM COMPONENTS
import ProfilePopover from '@/layouts/layout-parts/popovers/ProfilePopover';
import NotificationsPopover from '@/layouts/layout-parts/popovers/NotificationsPopover';
// STYLED COMPONENTS
import { DashboardHeaderRoot, StyledToolBar } from '../styles';

export default function DashboardHeader() {
  const { handleToggleSecondarySideBar } = useLayout();
  const { settings, saveSettings } = useSettings();
  const upSm = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const downMd = useMediaQuery(theme => theme.breakpoints.down(1200));

  const handleChangeTheme = value => {
    saveSettings({
      ...settings,
      theme: value
    });
  };

  return (
    <DashboardHeaderRoot position="sticky">
      <StyledToolBar>
        {/* MOBILE MENU BUTTON */}
        {downMd && (
          <IconButton
            onClick={handleToggleSecondarySideBar}
            sx={{
              mr: 1,
              color: 'text.secondary',
              '&:hover': {
                backgroundColor: theme => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
              },
            }}
          >
            <Menu />
          </IconButton>
        )}

        {/* SPACER */}
        <Box flexGrow={1} />

        {/* ACTION BUTTONS */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          sx={{
            '& .MuiIconButton-root': {
              color: 'text.secondary',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: theme => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
                transform: 'translateY(-1px)',
              },
            },
          }}
        >
          {/* THEME TOGGLE */}
          <IconButton
            onClick={() => handleChangeTheme(settings.theme === 'light' ? 'dark' : 'light')}
            size="small"
          >
            <ThemeIcon />
          </IconButton>

          {/* NOTIFICATIONS */}
          {upSm && <NotificationsPopover />}

          {/* PROFILE */}
          <ProfilePopover />
        </Stack>
      </StyledToolBar>
    </DashboardHeaderRoot>
  );
}